import { useFm } from '@web3/base-hooks';
import { TextLink } from '@bfe/moly';
import {
  STEP_LIST_ICON_1_IMG,
  STEP_LIST_ICON_2_IMG,
  STEP_LIST_ICON_3_IMG,
  STEP_LIST_ICON_4_IMG,
} from '@/constants';
import styles from './index.module.scss';
import { useRegisterModal } from '@/hooks/useRegisterModal';
import { useUserStatus } from '@/hooks/useUserStatus';
import { LoginStatus, UserStatus } from '@/types/user';
import { ActiveStatus } from '@/hooks/home';
import { isMobile } from '@web3/base-utils';
import Image from 'next/image';
import {
  TOTAL_REWARD_AMOUNT,
  GRANT_REWARD_PERSONAL_TOP,
} from '@/utils/constant';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';

const StepLine = ({ activeStatus }: { activeStatus: ActiveStatus }) => {
  const fm = useFm();
  const { checkStatusAndRegister } = useRegisterModal();
  const { userStatus, loginStatus } = useUserStatus();
  const showJoinNow =
    activeStatus === ActiveStatus.ON_GOING && loginStatus === LoginStatus.NONE;

  const stepList = [
    {
      num: 1,
      icon: STEP_LIST_ICON_1_IMG,
      title: fm('registerCampaignStep'),
      subTitle: fm('registerCampaignStepDesc'),
      content: showJoinNow && (
        <TextLink
          variant="primary"
          color="#83F6F9"
          size="small"
          onClick={() => {
            scTrack(Event.Web3UserClick, {
              page_name: Page.HomePage,
              button_name: 'Connect',
            });
            checkStatusAndRegister();
          }}
        >
          {fm('joinNow')}
        </TextLink>
      ),
    },
    {
      num: 2,
      icon: STEP_LIST_ICON_2_IMG,
      title: fm('earnVotingPointsStep'),
      subTitle: fm('earnVotingPointsStepDesc'),
    },
    {
      num: 3,
      icon: STEP_LIST_ICON_3_IMG,
      title: fm('voteForFavoritesStep'),
      subTitle: fm('voteForFavoritesStepDesc'),
    },
    {
      num: 4,
      icon: STEP_LIST_ICON_4_IMG,
      title: fm('unlockRewardsStep'),
      subTitle: fm('unlockRewardsStepDesc', {
        amount: GRANT_REWARD_PERSONAL_TOP,
      }),
    },
  ];

  const StepItem = ({ num, icon, title, subTitle, content = null }) => {
    return (
      <div className={styles.item}>
        <Image
          width={!isMobile ? 140 : 48}
          height={!isMobile ? 140 : 48}
          loader={({ src }) => src}
          src={icon}
          alt="icon"
        />
        {!isMobile && (
          <div className={styles.number}>
            <span>{num}</span>
          </div>
        )}
        <div className={styles.info}>
          <div className={styles.infoTitle}>{title}</div>
          <div className={styles.infoSubtitle}>{subTitle}</div>
          {content && <div className={styles.infoContent}>{content}</div>}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.top}>
        <div className={styles.title}>{fm('howToParticipateAIDol')}</div>
        <div className={styles.subTitle}>
          {fm('howToParticipateDesc', { amount: TOTAL_REWARD_AMOUNT })}
        </div>
      </div>

      <div className={styles.list}>
        {stepList?.map((item) => <StepItem key={item.num} {...item} />)}
      </div>
    </div>
  );
};

export default StepLine;
